import {
  Filter,
  FilterConfiguration,
  FilterForm,
  FilterOperator,
  FilterType,
} from "../models/filters.model";

export const OPERATORS_TRANSLATIONS: Record<FilterOperator, string> = {
  [FilterOperator.IS]: "libs.filters.operator.is",
  [FilterOperator.IS_NOT]: "libs.filters.operator.is-not",
  [FilterOperator.CONTAINS]: "libs.filters.operator.contains",
  [FilterOperator.AFTER]: "libs.filters.operator.after",
  [FilterOperator.BEFORE]: "libs.filters.operator.before",
  [FilterOperator.BETWEEN]: "libs.filters.operator.between",
};

export const filterToFilterFormFactory = (filter: Filter): FilterForm => {
  return {
    filter: filter.filter,
    operator: filter.operator,
    type: filter.type,
    value:
      filter.type === FilterType.DATE
        ? null
        : (filter.value as string | number | null),
    valueFrom:
      filter.type === FilterType.DATE ? (filter.valueFrom ?? null) : null,
    valueTo: filter.type === FilterType.DATE ? (filter.valueTo ?? null) : null,
  };
};

export const filterFormToFilterFactory = (
  config: FilterConfiguration[],
  form: FilterForm | null,
): Filter | null => {
  if (!form || !form.filter || !form.operator || !form.type) {
    return null;
  }

  const activeFilterConfig = config.find((c) => c.filter === form.filter);
  const label = activeFilterConfig?.label;
  const optionLabel =
    activeFilterConfig?.type === FilterType.SELECT
      ? activeFilterConfig?.options.find(
          (option) => option.value === form.value,
        )?.label
      : null;

  switch (form.type) {
    case FilterType.TEXT:
      if (form.value && typeof form.value === "string") {
        return {
          id: crypto.randomUUID(),
          filter: form.filter,
          label: label ?? form.filter,
          operator: form.operator,
          type: form.type,
          value: form.value.trim(),
        };
      }
      break;
    case FilterType.SELECT: {
      if (form.value && typeof form.value === "string") {
        return {
          id: crypto.randomUUID(),
          filter: form.filter,
          label: label ?? form.filter,
          operator: form.operator,
          type: form.type,
          value: form.value.trim(),
          optionLabel: optionLabel ?? form.value.trim(),
        };
      }
      break;
    }
    case FilterType.NUMBER: {
      if (form.value && typeof form.value === "number") {
        return {
          id: crypto.randomUUID(),
          filter: form.filter,
          label: label ?? form.filter,
          operator: form.operator,
          type: form.type,
          value: form.value,
        };
      }
      break;
    }
    case FilterType.DATE: {
      const hasValueFrom = form.valueFrom?.isValid;
      const hasValueTo = form.valueTo?.isValid;

      if (!hasValueFrom && !hasValueTo) {
        return null;
      }

      const dateFilter: Filter = {
        id: crypto.randomUUID(),
        filter: form.filter,
        label: label ?? form.filter,
        operator: form.operator,
        type: form.type,
        ...(hasValueFrom && form.valueFrom && { valueFrom: form.valueFrom }),
        ...(hasValueTo && form.valueTo && { valueTo: form.valueTo }),
      };

      return dateFilter;
    }
    default:
      return null;
  }

  return null;
};
